interface EmptyStateProps {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  action?: React.ReactNode;
}

export function EmptyState({ icon, title, description, action }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center">
      {icon && (
        <div className="rounded-full bg-neutral-100 p-4 mb-3">
          {icon}
        </div>
      )}
      <p className="text-sm font-medium text-neutral-900">{title}</p>
      {description && <p className="text-xs text-neutral-500 mt-1">{description}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
